export function jsonToBase64(object: { [key: string]: string }) {
	const json = JSON.stringify(object);
	return Buffer.from(json).toString('base64');
}
